import { Link } from 'react-router-dom'
import { Seo } from '@/components/seo/Seo'
import { BookingButton } from '@/components/booking/BookingButton'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { DecoratedHeader } from '@/components/ui/DecoratedHeader'

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Rodeo Nails" description="That page does not exist." path="/404" />
      <Section pageLead>
        <Container className="text-center">
          <DecoratedHeader
            size="hero"
            align="center"
            eyebrow="404"
            hideEyebrowRule
            title="This page wandered off"
            description="Head home or use the booking button."
            className="mx-auto"
          >
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/"
                className="inline-flex min-h-12 items-center justify-center rounded-[var(--radius-button)] border border-ink px-6 font-medium text-ink hover:bg-canvas-muted"
              >
                Home
              </Link>
              <BookingButton />
            </div>
          </DecoratedHeader>
        </Container>
      </Section>
    </>
  )
}
